import { useEffect } from "react";
import ModalBackdrop from "./ui/ModalBackdrop";

interface Props {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

// Generic modal wrapper for capture flows (paste, record call, file, etc.).
// Click the backdrop or press Escape to close; inner panels bring their own
// behaviour / progress UI.
export default function CaptureOverlay({ title, onClose, children }: Props) {
  useEffect(() => {
    function onKeyDown(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    window.addEventListener("keydown", onKeyDown);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return (
    <ModalBackdrop onClose={onClose}>
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="capture-overlay-title"
        className="capture-overlay-card"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="capture-overlay-header">
          <h2 id="capture-overlay-title" className="modal-title">
            {title}
          </h2>
          <button
            type="button"
            className="btn-icon"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        <div className="capture-overlay-body">{children}</div>
      </div>
    </ModalBackdrop>
  );
}
